import React, { useEffect, useState } from "react";
import "./account.css";
import DefaultProfileImage from "../../images/DefaultProfileImage.png";
import { Form, Formik } from "formik";
import * as yup from "yup";
import CustomInput from "../../components/CustomInput/CustomInput";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../../pages/getToken";
import authStore from "../../store/authStore";
import { HiOutlinePlusCircle } from "react-icons/hi";
import Modal from "../../components/Modal/modal";
import AntFileUpload from "../../components/AntFileUpload/AntFileUpload";

const Account = () => {
  const [isProfile, setIsProfile] = useState(true);
  const [isPassword, setIsPassword] = useState(false);
  const [user, setUser] = useState({ userName: "", email: "", image: "" });
  const auth = authStore((state) => state.auth);
  const secretCode = authStore((state) => state.secretCode);
  const password = secretCode;
  const [showUpload, setShowUpload] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [previewFiles, setPreviewFiles] = useState(null);

  const btnClickProfile = () => {
    setIsProfile(true);
    setIsPassword(false);
  };

  const btnClickPassword = () => {
    setIsProfile(false);
    setIsPassword(true);
  };

  let profileValidationSchema = yup.object().shape({
    username: yup.string().required("Please enter the username."),
    email: yup
      .string()
      .test("email", "Please enter the correct email address.", (val) =>
        apiUtil.emailValidation(val)
      )
      .required("Please enter the email address"),
  });

  //password and old password validation here.
  let passwordValidationSchema = yup.object().shape({
    oldPassword: yup.string().required("Please enter the current password."),
    newPassword: yup.string().required("Please enter the new password."),
    confirmPassword: yup
      .string()
      .required("Please enter the confirmed password.")
      .test("len", "Password must be at least 8 characters.", (val) =>
        val && val.length >= 8
      )
      .when("newPassword", {
        is: (val) => (val && val.length > 0),
        then: yup
          .string()
          .oneOf(
            [yup.ref("newPassword")],
            "Both passwords need to be the same"
          ),
      }),
  });

  const [profileInitialValues, setProfileInitialValues] = useState({
    username: "",
    email: "",
    organizationName: "",
    loginType: "",
  });
  const brandId = auth?.brandId;
  const getAdminInfo = () => {
    const param = {
      userId: auth.userId,
      brandId: brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then(
      (result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              redirectToLogin();
            } else if (response.data.code === 200) {
              setUser(response.data.data);
              setProfileInitialValues({
                username: user.userName,
                email: user.email,
                organizationName: user.organizationName,
                loginType: "1",
              });
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            alert(error);
          }
        ),
      (error) => {
        console.log(error);
      }
    );
  };

  const handleProfileSubmit = (values, actions) => {
    const profile = {
      userId: auth.userId,
      brandId: brandId,
      name: values.username,
      phone: user.phone,
      email: values.email,
    };

    api.post("Admin/UpdateAdmin", profile, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            redirectToLogin();
          } else if (response.data.code === 200) {
            alert("Admin profile updated successfully!!");
            getAdminInfo();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSubmitting(false);
  };

  const handlePasswordSubmit = (values, actions) => {
    const changePassword = {
      userId: auth.userId,
      ...values,
    };

    api
      .post("Admin/AdminChangePassword", changePassword, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              redirectToLogin();
            } else if (response.data.code === 200) {
              alert("Admin password changed successfully!!");
              getAdminInfo();
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        )
      );
    actions.setSubmitting(false);
  };

  const showModal = () => {
    setShowUpload(true);
  };

  const hideModal = () => {
    setShowUpload(false);
  };

  const handleUploadProfileImage = (values, actions) => {
    const userProfileImage = {
      userId: auth.userId,
      brandId: brandId,
      image: values.files[0].url.replace(/^data:(.*,)?/, ""),
    };

    api
      .post("Admin/AdminUploadProfile", userProfileImage, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              redirectToLogin();
            } else if (response.data.code === 200) {
              alert("Profile picture uploaded successfully!!");
              setShowUpload(false);
              setPreviewFiles(null);
              window.location.reload();
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        )
      );

    actions.setSubmitting(false);
  };

  useEffect(() => {
    getAdminInfo();
  }, []);

  return (

    <div className="account">
      <h4 className="title_text Account_title">Account</h4>
      <div className="Header_Container">
        <button
          className={`Profile_Btn ${isProfile ? "btnActive" : ""}`}
          onClick={btnClickProfile}
        >
          Profile
        </button>
        <button
          className={`Password_Btn ${isPassword ? "btnActive" : ""}`}
          onClick={btnClickPassword}
        >
          Password
        </button>
      </div>

      {!isPassword && (
        <div className="Profile_form">
          <div className="Profile">
            <button
              type="button"
              className="btnProfilePic"
              onClick={showModal}
            >
              <img
                src={user.image ? user.image : DefaultProfileImage}
                className="Person_Image rounded-circle"
                alt="profile_image"
              />
              <HiOutlinePlusCircle className="icon-plus" />
            </button>
            <div className="Info">
              <h1 className="">{user.organizationName}</h1>
              <p className="name">{user.userName}</p>
              <p className="email">{user.email}</p>
              {/* <p className="name">{user.organizationName}</p> */}
            </div>
          </div>
          <div className="Profile_form">
            <Formik
              initialValues={{
                username: user.userName ? user.userName : "",
                email: user.email ? user.email : "",
                loginType: "1",
              }}
              enableReinitialize={true}
              validationSchema={profileValidationSchema}
              validateOnBlur={false}
              onSubmit={handleProfileSubmit}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form className="row account-form">
                    <CustomInput
                      name="username"
                      type="username"
                      label="Username"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                    <CustomInput
                      name="email"
                      type="email"
                      label="Email"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                    <div className="Actions justify-content-end mt-12">
                      <button type="button" className="button btnCancel">
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        Save Profile
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
          {/* Upload Admin Picture Form */}
          <Modal showModal={showUpload} close={true} hideModal={hideModal}>
            <div className="uploadAdminPhoto">
              <Formik
                initialValues={{
                  files: null,
                }}
                validationSchema={yup.object().shape({
                  files: yup
                    .array()
                    .nullable()
                    .required("Please choose the profile picture."),
                })}
                validateOnBlur={false}
                enableReinitialize={true}
                onSubmit={(values, actions) => {
                  setPreviewFiles(values.files);
                  handleUploadProfileImage(values, actions);
                }}
              >
                {({ values, errors, touched, setFieldValue }) => (
                  <>
                    {!values.files && (
                      <img
                        src={
                          previewFiles
                            ? previewFiles[0].url
                            : user.image || DefaultProfileImage
                        }
                        alt="ProfileImage"
                        className="imgUpload"
                      />
                    )}
                    <h4>Upload</h4>
                    <Form className=" upload-pic-form">
                      <div className={`${fileSizeError && "mb-3"}`}>
                        <AntFileUpload
                          name="files"
                          inputText={
                            <>
                              <span>Drag and drop here </span>
                              <span>or</span>
                              <span className="btnChooseFiles">
                                Upload Profile Picture
                              </span>
                            </>
                          }
                          aspectRatio={9 / 3}
                          multiiple="false"
                          imageQuality={0.8}
                          accept={".png, .jpg, .jpeg"}
                          onChange={({ fileList: newFileList }) => {
                            if (newFileList.length > 0) {
                              // Only a file upload. if the fileList length is greater than 1, remove index 0;
                              if (newFileList.length > 1) {
                                newFileList.shift();
                              }
                              newFileList = newFileList.map((file) => {
                                return {
                                  ...file,
                                  status: "done",
                                  percent: 100,
                                  response: "Success",
                                };
                              });
                              const successFiles = newFileList.filter(
                                (file) => file.status !== "error"
                              );
                              const failedFiles = newFileList.filter(
                                (file) => file.status === "error"
                              );
                              if (failedFiles.length > 0) {
                                setFileSizeError(true);
                              }
                              setFieldValue("files", successFiles);
                            } else {
                              setFieldValue("files", null);
                              setPreviewFiles(null);
                            }
                          }}
                          onRemove={(file) => {
                            if (file.url) {
                              setFieldValue("deletedImage", [
                                ...values.deletedImage,
                                file,
                              ]);
                            }
                          }}
                        />
                        {fileSizeError && (
                          <div className=" error__text">
                            One of the images is greater than specified image
                            size
                          </div>
                        )}
                      </div>
                      <div className="d-block text-center">
                        <button type="submit" className="btnConfirm">
                          Upload
                        </button>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Modal>
        </div>
      )}

      {!isProfile && (
        <div>
          <div className="Password_form">
            <Formik
              initialValues={{
                oldPassword: password ? Buffer.from(password, 'base64').toString('utf-8') : "",
                newPassword: "",
                confirmPassword: "",
              }}
              validateOnBlur={false}
              validationSchema={passwordValidationSchema}
              onSubmit={handlePasswordSubmit}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form className="row account-form">
                    <CustomInput
                      name="oldPassword"
                      type="password"
                      label="Current Password"
                      customclass="input_wrapper"
                    />
                    <CustomInput
                      name="newPassword"
                      type="password"
                      label="New Password"
                      customclass="input_wrapper"
                    />
                    <CustomInput
                      name="confirmPassword"
                      type="password"
                      label="Confirm New Password"
                      customclass="input_wrapper"
                    />
                    <div className="Actions justify-content-end mt-12">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={() => btnClickProfile()}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        Change
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      )}
    </div>

  );
};

export default Account;
